// extracted by mini-css-extract-plugin
module.exports = {"slider":"Slider_slider__2rGk-","item":"Slider_item__2305S","imgContain":"Slider_imgContain__32_bu","content":"Slider_content__XSIpR"};